import { useServices } from "@core/servicesContext";
import { AsyncResult, PaginatedDataResult, useMappedStore, useStoredData } from "@utils/hooks";
import { useCurrentProfile } from "@domain/currentProfile/hooks";
import { Experience, ExperienceType } from "./experience";

export function useMyExperiences(type: ExperienceType): PaginatedDataResult<Experience> {
	const currentProfile = useCurrentProfile();
	return useUserExperiences(currentProfile?.id ?? "", type);
}

export function useExperience(id: string): AsyncResult<Experience> {
	const { experienceService } = useServices();
	const currentProfile = useCurrentProfile();
	return useStoredData(id, experienceService.experienceStore, [currentProfile?.id]);
}

export function useUserExperiences(userId: string, type: ExperienceType): PaginatedDataResult<Experience> {
	const { experienceService } = useServices();
	const userStore =
		type === ExperienceType.ACADEMIC
			? experienceService.userAcademicExperiencesStore
			: experienceService.userProfessionalExperiencesStore;
	return useMappedStore(userId, userStore, [userId]);
}
